import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UsuarioEmpresaListarModule } from "./usuario-empresa-listar/usuario-empresa-listar.module";
import { UsuarioEmpresaInserirModule } from "./usuario-empresa-inserir/usuario-empresa-inserir.module";
import { UsuarioEmpresaEditarModule } from "./usuario-empresa-editar/usuario-empresa-editar.module";
import { UsuarioEmpresaDetalharModule } from "./usuario-empresa-detalhar/usuario-empresa-detalhar.module";

@NgModule({
    imports: [
        CommonModule,     
        UsuarioEmpresaListarModule,
        UsuarioEmpresaInserirModule,
        UsuarioEmpresaEditarModule,
        UsuarioEmpresaDetalharModule
    ],
    exports: [ 
        UsuarioEmpresaListarModule,
        UsuarioEmpresaInserirModule,
        UsuarioEmpresaEditarModule,
        UsuarioEmpresaDetalharModule
    ]
})
export class UsuarioEmpresaAppModule { }
